
import {ConfigContext} from "./ConfigContext";
import {useContext, useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import configJson from "../02wsconfig.json";
export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used inside a <ConfigProvider>");
  }
  return context;
}

export function ConfigProvider({ children }) {

  const { t, i18n } = useTranslation();
  const [configData, setConfig] = useState(() => {
   try {
      const stored = localStorage.getItem("configData");
      return stored ? JSON.parse(stored) : configJson;
     
    } catch (err) {
      console.error("Failed to parse config from localStorage", err);
      return configJson;
    }
  });

  // Save to localStorage when config changes
  useEffect(() => {
    try {
      localStorage.setItem("configData", JSON.stringify(configData));
      console.log('saved in useConfig: ', configData); 
    } catch (err) {
      console.error("Failed to save config to localStorage", err);
    }
  }, [configData]);

   useEffect(() => {
    if (configData?.lang) {
      i18n.changeLanguage(String(configData.lang));
    }
  }, [configData, i18n]);

  // Add reset helper
  const resetConfig = () => {
    setConfig(configJson);
    localStorage.removeItem("configData");
  };

  const setClassesToRoot = (classes) =>  {
     console.log('setClassesToRoot:', classes);
     let root = document.getElementById("root");
    
    if (classes !== "")
       root.classList.add(classes);
  }


  return (
    <ConfigContext.Provider value={{configData, setConfig, resetConfig, setClassesToRoot}}>
      {children}
    </ConfigContext.Provider>
  );
}